module.exports = __webpack_public_path__ + "static/media/road-runner.c4d6e82d.gif";